module.exports = __webpack_public_path__ + "src/img/marleyspoon/marleyspoon-image-4.942e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/marleyspoon/marleyspoon-image-4.png
// module id = 254
// module chunks = 0